const keyName=[{
    key:'3.1.1',
    name:'冷水机组喘振现象'
},{
    key:'3.1.2',
    name:'高压报警现象'
},{
    key:'3.1.3',
    name:'水流开关/电动阀故障'
},{
    key:'3.2.1',
    name:'水泵明显的振动现象'
},{
    key:'3.2.2',
    name:'水泵漏水现象'
},{
    key:'3.2.3',
    name:'水泵与管道处软接变形/裂口'
},{
    key:'3.2.4',
    name:'电机温度过高现象/裂口'
},{
    key:'3.2.5',
    name:'电流超载现象'
},{
    key:'3.3.1',
    name:'水泵明显的振动现象'
},{
    key:'3.3.2',
    name:'水泵漏水现'
},{
    key:'3.3.3',
    name:'水泵与管道处软接变形/裂口'
},{
    key:'3.3.4',
    name:'电机温度过高现象'
},{
    key:'3.3.5',
    name:'电流超载现象'
},{
    key:'3.4.1',
    name:'冷却塔明显振动'
},{
    key:'3.4.2',
    name:'风机反转/皮带松弛/风机故障等现象'
},{
    key:'3.4.3',
    name:'冷却塔布水不均匀现象'
},{
    key:'3.4.4',
    name:'补水系统不正常'
},{
    key:'3.4.5',
    name:'冷塔填料不正常'
},{
    key:'4.1.1',
    name:'冷站群控纯手工运行'
},{
    key:'4.1.2',
    name:'传感器不准确'
},{
    key:'4.1.3',
    name:'自控系统硬件不能正常使用、部分传感器无信号、传感器接线断掉等'
},{
    key:'4.1.4',
    name:'自控系统通讯不支持第三方'
},{
    key:'4.1.5',
    name:'自控软件不易操作，无相关交互'
},{
    key:'4.1.6',
    name:'冷机只能简单常规控制(定时开关机等)'
},{
    key:'4.1.7',
    name:'水泵只能简单常规控制'
},{
    key:'4.1.8',
    name:'冷却塔只能简单常规控制'
},{
    key:'4.1.9',
    name:'自控数据无存储'
},{
    key:'5.1.1',
    name:'空调系统运行记录、设备台帐、巡检记录、维保记录没有保存相关记录'
},{
    key:'5.1.2',
    name:'冷水机组冷凝器不进行清洗'
},{
    key:'5.1.3',
    name:'空调系统能耗没有抄表记录或有抄表记录但不完整'
},{
    key:'5.1.4',
    name:'冷站群控无维保计划'
},{
    key:'5.1.5',
    name:'温度传感器/流量传感器等不进行校核'
}]
export default {
    keyName
}



// WEBPACK FOOTER //
// ./src/assets/js/baseData.js